<template>
	<div style="min-width: 1000px;">
		<div style="text-align: left;padding-top: 20px;">
			<router-link to="/productregister" style="color: #409EFF;"><i class="el-icon-arrow-left"></i> 返回码标注册</router-link>
		</div>
		<div style="color: #f56c6c;text-align: left;padding: 20px 0 20px 60px;font-size: 14px;" v-if="$store.state.commonalityData.IdcodeUserId===''">
			您当前账号未完善信息，请点击完善资料前往填写信息再使用此功能
			<router-link to="/perfect" style="color: rgb(64, 158, 255);margin-left: 20px;">完善资料</router-link>
		</div>

		<div style="color: #f56c6c;text-align: left;padding: 20px 0 20px 60px;font-size: 14px;" v-else>
			请按照提示完成受限词注册流程
			<router-link to="/perfect" style="color: rgb(64, 158, 255);margin-left: 20px;">查看资料</router-link>
		</div>
		<div style="text-align: left;">
			<a href="/UploadFiles/限制或特殊词汇注册申请表.docx" download="限制词注册申请表" class="download-word el-icon-edit">限制词注册申请表下载</a>
		</div>

		<div class="conEX-box f-cb">
			<!--<h1 class="tit">限制词码标注册提交</h1>-->

			<div class="ceform-box">
				<!--<h1 class="tit">限制词码标注册提交</h1>-->

				<el-form ref="form" :model="form" label-width="150px" :disabled="formDisabled" :rules="rules">
					<el-form-item label="码标名称：">
						<!--<el-input v-model="form.name"></el-input>-->
						<span>{{form.name}} </span>

						<!--<span style="margin-left: 10px;"><span style="color: #606266;">价格： </span> <span v-html="priceUnbind"></span></span>-->
					</el-form-item>
					
					<el-form-item label="价格：">
						<span v-html="priceUnbind"></span>
					</el-form-item>

					<el-form-item prop="applicationFormImg" label="申请表图片： ">
						<file-upload ref="upload" v-model="files" input-id="files" style="vertical-align: middle;" :post-action="$api+'/upload/uploadImageOrZip'" @input-file="inog" @input-filter="inputFilter" :size="1024 * 1024*5" @input="updatetValue('upload')">
							<el-button type="primary" plain>上传文件</el-button>
							<!--<div class="el-upload__tip" style="display: inline-block;margin-left: 20px;">申请表填写完后打印盖章扫描上传 （多个图打包后上传）</div>-->
						</file-upload>
						<div class="el-upload__tip" style="display: inline-block;margin-left: 20px;">
							申请表填写完后打印盖章扫描上传 （多个图打包后上传）
							<!--	<br />-->

						</div>
						<!--<div class="el-upload__tip" style="margin-left: 20px;display: inline-block;">
								 （多个图打包后上传）
							 
							</div>-->
						<div v-if="form.applicationFormImg!=''">
							<div class="upload-data-strip f-cb" v-show="/\.(jpeg|jpe|jpg|gif|png|webp|bmp)$/i.test(form.applicationFormImg.entity.fileNewName)" @click="amplificationImg(form.applicationFormImg.entity.fileNewName)">
								<i class="el-icon-tickets"></i>
								<span>
							
                        	{{form.applicationFormImg!=''?form.applicationFormImg.entity.fileOldName:''}}
                        	</span>
								<span class="f-fr" style="cursor: pointer;">
                        	查看
                            </span>
							</div>

							<!--下载-->
							<div class="upload-data-strip f-cb" v-show="/\.(rar|iso|zip|cab)$/i.test(form.applicationFormImg.entity.fileNewName)" @click="download(form.applicationFormImg.entity.fileUrl+form.applicationFormImg.entity.fileNewName)">
								<i class="el-icon-tickets"></i>
								<span>
							
                        	{{form.applicationFormImg!=''?form.applicationFormImg.entity.fileOldName:''}}
                        	</span>
								<span class="f-fr" style="cursor: pointer;">
                        	下载
                            </span>
							</div>
						</div>
						<!--</transition>-->
						<!--<template slot-scope="error">
						</template>-->
						<!--<div slot="error">111</div>-->
						<!--<div class="el-upload__tip">申请表填写万后打印盖章扫描上传 （多个图打包后上传）</div>-->
					</el-form-item>

					<el-form-item label="营业执照图片：" prop="OperatinglicenseImg">

						<file-upload ref="upload1" v-model="files1" style="vertical-align: middle;" input-id="files1" :post-action="$api+'/upload/uploadImageFile'" @input-file="Operatinglicense" @input-filter="inputFilterImg" :size="1024 * 1024*5" @input="updatetValue('upload1')">
							<el-button type="primary" plain>上传图片</el-button>

						</file-upload>
						<div class="el-upload__tip" style="display: inline-block;margin-left: 20px;">企业、机构事业单位、组织团体的营业执照图片</div>
						<!--<classify :materials='form.OperatinglicenseImg'></classify>-->
						<div v-if="form.OperatinglicenseImg">
							<div class="upload-data-strip f-cb" v-show="/\.(jpeg|jpe|jpg|gif|png|webp|bmp)$/i.test(form.OperatinglicenseImg.entity.name)" @click="amplificationImg(form.OperatinglicenseImg.entity.imageBig)">
								<i class="el-icon-tickets"></i>
								<span>
							
                        	{{form.OperatinglicenseImg?form.OperatinglicenseImg.entity.name:''}}
                        	</span>
								<span class="f-fr" style="cursor: pointer;">
                        	查看
                            </span>
							</div>
						</div>
						<!--<div class="el-upload__tip">企业、机构事业单位、组织团体的运营执照图片</div>-->

					</el-form-item>
					<!--<el-form-item label="身份证正面图片：" prop="frontOfIDcardImg">
						<file-upload ref="upload2" v-model="files2" input-id="files2" style="vertical-align: middle;" :post-action="$api+'/upload/uploadImageFile'" @input-file="frontOfIDcard" @input-filter="inputFilterImg" :size="1024 * 1024*5" @input="updatetValue('upload2')">
							<el-button type="primary" plain>上传图片</el-button>

						</file-upload>
						<div class="el-upload__tip" style="display: inline-block;margin-left: 20px;">企业负责人的身份证正面照片</div>
				
						<div v-if="form.frontOfIDcardImg">
							<div class="upload-data-strip f-cb" v-show="/\.(jpeg|jpe|jpg|gif|png|webp|bmp)$/i.test(form.frontOfIDcardImg.entity.name)" @click="amplificationImg(form.frontOfIDcardImg.entity.imageBig)">
								<i class="el-icon-tickets"></i>
								<span>
							
                        	{{form.frontOfIDcardImg?form.frontOfIDcardImg.entity.name:''}}
                        	</span>
								<span class="f-fr" style="cursor: pointer;">
                        	查看
                            </span>
							</div>
						</div>
					

					</el-form-item>-->
					<!--<el-form-item label="身份证国徽面图片：" prop="NationalEmblem">
						
						<file-upload ref="upload3" v-model="files3" input-id="files3" style="vertical-align: middle;" :post-action="$api+'/upload/uploadImageFile'" @input-file="NationalEmblemImg" @input-filter="inputFilterImg" :size="1024 * 1024*5" @input="updatetValue('upload3')">
							<el-button type="primary" plain>上传图片</el-button>

						</file-upload>
						<div class="el-upload__tip" style="display: inline-block;margin-left: 20px;">企业负责人的身份证国徽照片</div>
						<div v-if="form.NationalEmblem!=''">
							<div class="upload-data-strip f-cb" v-show="/\.(jpeg|jpe|jpg|gif|png|webp|bmp)$/i.test(form.NationalEmblem.entity.name)" @click="amplificationImg(form.NationalEmblem.entity.imageBig)">
								<i class="el-icon-tickets"></i>
								<span>
							
                        	{{form.NationalEmblem!=''?form.NationalEmblem.entity.name:''}}
                        	</span>
								<span class="f-fr" style="cursor: pointer;">
                        	查看
                            </span>
							</div>
						</div>

					</el-form-item>-->
		

					<el-form-item>
						<el-button type="primary" @click="onSubmit" style="width: 100px;">提交注册</el-button>
						<!--<el-button>取消</el-button>-->
					</el-form-item>
				</el-form>
				<!--<h1 class="tit">组织/单位基本资料</h1>
				<el-form ref="form" :model="form" label-width="150px">
					<el-form-item label="码标名称：">
						<el-input v-model="form.name"></el-input>
					</el-form-item>
					<el-form-item label="申请表图片：">
						<el-button type="primary">上传图片</el-button>
					</el-form-item>
					<el-form-item label="手机号：">
						<el-input v-model="form.name"></el-input>
					</el-form-item>
					<el-form-item label="验证码：">
						<el-input v-model="form.name"></el-input>
					</el-form-item>
					<el-form-item label="特殊资源">
						<el-radio-group v-model="form.resource">
							<el-radio label="线上品牌商赞助"></el-radio>
							<el-radio label="线下场地免费"></el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="活动形式">
						<el-input type="textarea" v-model="form.desc"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">立即创建</el-button>
						<el-button>取消</el-button>
					</el-form-item>
				</el-form>-->
			</div>
			<img src="../assets/imgs/flowPath.png" style="float: left;position: relative;bottom: 120px;"/>
		</div>
		<!--<img src="../assets/imgs/Maregister.jpg" style="display: inline-block;width: 60%;" />-->
	</div>
</template>

<script>
	import FileUpload from 'vue-upload-component'
	import Classify from '@/components/Classify.vue'

	export default {
		components: {
			FileUpload,
			Classify
		},
		data() {
			return {
				files: [{}],
				files1: [],
				files2: [],

				files3: [],

				formDisabled: true,
				form: {
					name: '',
					applicationFormImg: '',
					OperatinglicenseImg: '',
					frontOfIDcardImg: '',
					NationalEmblem: '',
					region: '',
					price: [{
						value: '',
						label: ''
					}],
				},
				rules: {
					name: [{
						required: true,
						trigger: 'blur'
					}, ],
					applicationFormImg: {
						required: true,
						message: '请上传申请表图片',
						trigger: 'blur'
					},
					OperatinglicenseImg: {
						required: true,
						message: '运营执照图片',
						trigger: 'blur'
					},
					NationalEmblem: {
						required: true,
						message: '企业负责人的身份证正面照片',
						trigger: 'blur'
					},
					frontOfIDcardImg: {
						required: true,
						message: '企业负责人的身份证国徽照片',
						trigger: 'blur'
					},
				}
			}
		},
		props: {
			name: String,
			price: String,
		},
		created() {
			this.form.name = unescape(this.name);
		
                    if( this.$store.state.commonalityData.IdcodeUserId){
                    		this.formDisabled = false;
                    }else{
                    	this.formDisabled =true
                    }
//			this.$datumSane().then(resolve => {
//				this.formDisabled = false;
//			}, reject => {
//				this.formDisabled = true;
//
//			})

		},
		computed: {
			
			priceUnbind(){
				return this.price?unescape(this.price):''
			}
			
		},
		methods: {
			onSubmit() {
				this.$refs.form.validate((valid) => {
					if(valid) {
						let {
							form
						} = this;
						this.$http.post(this.$api + '/identificationApply/identificationReg', {
							domain: this.$store.state.commonalityData.official,
							identification: unescape(this.name),
							limiterFile: form.applicationFormImg.entity.fileNewName,
							licensePicture: form.OperatinglicenseImg.entity.imageBig,
//							IDcardPicture: form.NationalEmblem.entity.imageBig + '|' + form.frontOfIDcardImg.entity.imageBig,
							regSource: 1,

						}).then(res => {
							if(res.body.result === 1) {
								this.$router.push({
									path: 'audit'
								})
							} else {
								this.$message.error(res.body.message);
								//                             this.								
							}
						})
					} else {
						//						console.log('error submit!!');

						return false;
					}
				});
			},
			updatetValue(value) {
				this.$refs[value].active = true;

			},
			inputFilter: function(newFile, oldFile, prevent) {
				if(newFile && !oldFile) {
					// 过滤不是图片后缀的文件
					if(!/\.(jpeg|jpe|jpg|gif|png|webp|bmp|rar|iso|zip|cab)$/i.test(newFile.name)) {
					this.$message.error('仅支持jpg.png.gif.jpeg.bmp后缀图片和.rar.iso.zip.cab压缩文件上传');
						return prevent()
					}
					if(newFile.size>1024 * 1024*5){
					this.$message.error('请上传5MB以内的文件');
						
					}
//					console.log()
				}

				// 创建 blob 字段 用于图片预览
				newFile.blob = ''
				let URL = window.URL || window.webkitURL
				if(URL && URL.createObjectURL) {
					newFile.blob = URL.createObjectURL(newFile.file)
				}
			},
			inputFilterImg(newFile, oldFile, prevent) {
				if(newFile && !oldFile) {
					// 过滤不是图片后缀的文件
					if(!/\.(jpeg|jpe|jpg|gif|png|webp|bmp)$/i.test(newFile.name)) {
						this.$message.error('仅支持jpg.png.gif.jpeg.bmp后缀图片上传');
						
						
						
						return prevent()
					}
					if(newFile.size>1024 * 1024*5){
					this.$message.error('请上传5MB以内的文件');
						
					}
					
				}

				// 创建 blob 字段 用于图片预览
				newFile.blob = ''
				let URL = window.URL || window.webkitURL
				if(URL && URL.createObjectURL) {
					newFile.blob = URL.createObjectURL(newFile.file)
				}
			},
			inog(newFile, oldFile) {
				//申报表
				if(newFile && oldFile && !newFile.active && oldFile.active) {
					if(newFile.xhr) {
						let res = JSON.parse(newFile.xhr.response)

						if(res.result == 1) {
							if(res.entity != undefined) {
								this.form.applicationFormImg = res;
								//								console.log(res)
							}
						} else {
							this.$message({
								showClose: true,
								message: res.message,
								duration: '1000',
								type: 'error'
							});
						}
					} else if(newFile.iframe) {
						if(newFile.response.entity) {
							let res = newFile.response

							if(res.result == 1) {
								this.form.applicationFormImg = res;
								console.log(res)

							} else {
								this.$message({
									showClose: true,
									message: res.message,
									duration: '1000',
									type: 'error'
								});
							}
						}
					}
				}
			},
			Operatinglicense(newFile, oldFile) {
				if(newFile && oldFile && !newFile.active && oldFile.active) {

					if(newFile.xhr) {
						let res = JSON.parse(newFile.xhr.response)
						if(res.result == 1) {
							if(res.entity != undefined) {
								this.form.OperatinglicenseImg = res;
							}
						} else {
							this.$message({
								showClose: true,
								message: res.message,
								duration: '1000',
								type: 'error'
							});
						}
					} else if(newFile.iframe) {
						if(newFile.response.entity) {
							let res = newFile.response

							if(res.result == 1) {
								this.form.OperatinglicenseImg = res;
								console.log(res)

							} else {
								this.$message({
									showClose: true,
									message: res.message,
									duration: '1000',
									type: 'error'
								});
							}
						}
					}
				}
			},
			frontOfIDcard(newFile, oldFile) {
				if(newFile && oldFile && !newFile.active && oldFile.active) {

					if(newFile.xhr) {
						let res = JSON.parse(newFile.xhr.response)
						if(res.result == 1) {
							if(res.entity != undefined) {
								this.form.frontOfIDcardImg = res;
							}
						} else {
							this.$message({
								showClose: true,
								message: res.message,
								duration: '1000',
								type: 'error'
							});
						}
					} else if(newFile.iframe) {
						if(newFile.response.entity) {
							let res = newFile.response

							if(res.result == 1) {
								this.form.frontOfIDcardImg = res;
								console.log(res)

							} else {
								this.$message({
									showClose: true,
									message: res.message,
									duration: '1000',
									type: 'error'
								});
							}
						}
					}
				}
			},
			NationalEmblemImg(newFile, oldFile) {
				if(newFile && oldFile && !newFile.active && oldFile.active) {

					if(newFile.xhr) {
						let res = JSON.parse(newFile.xhr.response)
						if(res.result == 1) {
							if(res.entity != undefined) {
								this.form.NationalEmblem = res;
							}
						} else {
							this.$message({
								showClose: true,
								message: res.message,
								duration: '1000',
								type: 'error'
							});
						}
					} else if(newFile.iframe) {
						if(newFile.response.entity) {
							let res = newFile.response

							if(res.result == 1) {
								this.form.NationalEmblem = res;
								console.log(res)

							} else {
								this.$message({
									showClose: true,
									message: res.message,
									duration: '1000',
									type: 'error'
								});
							}
						}
					}
				}
			},
//			201903271030429642671000
//			201903271030296047731000
			amplificationImg(url) {
				//			console.log(url)
				this.$alert('<img src=' + '/UploadImages/' + url + '></img>', {
					showConfirmButton: false,
					dangerouslyUseHTMLString: true,
					customClass: 'imgalert',
					callback: (done) => {
						//						done();
					}
				});
			},
			//			window.location="htpp://www.baidu.com/test.rar";
			download(url) {
				window.location = window.location.protocol + "//" + window.location.host + url;

			}
		}
	}
</script>

<style lang="scss" scoped>
	.conEX-box {
		/*padding-top: 20px;*/
	}
	
	.el-upload__tip {
		/*border: solid red 1px;*/
		font-size: 13px;
		padding: 0 0;
	}
	
	.ceform-box {
		.tit {
			padding: 20px;
			font-weight: 600;
			color: #333333;
			/*border: solid red 1px;*/
			text-align: center;
			font-size: 16px;
		}
		float: left;
		width: 60%;
		text-align: left;
		/*border: solid red 1px;*/
	}
	
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	
	.upload-data-strip {
		color: #606266;
		display: block;
		margin-right: 40px;
		overflow: hidden;
		width: 400px;
		/*padding:  4px;*/
		/*line-height: 10px;*/
		text-overflow: ellipsis;
		transition: color .3s;
		cursor: pointer;
		white-space: nowrap;
		/*background-color: rgb(217, 236, 255);*/
		border-radius: 5px;
		&:hover {
			color: #1B59A8;
			/*rgb(179, 216, 255)*/
			/*background-color: rgb(236, 245, 255);*/
			/*border-bottom: solid  rgb(236, 245, 255) 1px;*/
		}
	}
/*	/UploadImages/201903271029520173981000.jpg*/
	.imgalert {
		img{
			width: 100% ;
			
		}
	}
	
	.download-word {
		text-align: left;
		color: #1B59A8;
		display: inline-block;
		margin-left: 60px;
		padding-bottom: 20px;
	}
</style>